export const PRO_GALLERY = {
  SENTRY_DSN: 'https://53ff996300e94e7983242fc53bc63c5f@sentry.io/1360936',
  PG_APP_DEFINITION_ID: '14271d6f-ba62-d045-549b-ab972ae1f70e',
  GALLERY_WIDGET_ID: '142bb34d-3439-576a-7118-683e690a1e0d',
  MULTISHARE_WIDGET_ID: '1491fc25-fcd2-9c08-c74f-67b98b69ac4a',
  FULLSCREEN_PAGE_ID: '144f04b9-aab4-fde7-179b-780c11da4f46',
  PG_TEST_APP_DEFINITION_ID: 'f27276e7-0858-460c-a450-4ba27cfe6eea',
  PG_TEST_GALLERY_WIDGET_ID: 'c89921a0-ef16-45a8-931d-e7d3e5a02cdf',
};

export const ART_STORE = {
  ARTSTORE_APP_DEFINITION_ID: '147ab90e-91c5-21b2-d6ca-444c28c8a23b',
  GALLERY_WIDGET_ID: '147ab9e6-2166-63ea-f9f1-3e81db0cbb4a',
  SENTRY_DSN: 'https://3d1ec62f015b4ad596910434ee40cf00@sentry.io/1533728',
};

export const ARTSTORE_PUBSUB_ENUMS = {
  OOI_MESSAGE: 'ARTSTORE_OOI_MESSAGE',
  CART_ITEMS_CHANGE: 'ARTSTORE_OOI_CART_ITEMS_CHANGE',
  REFRESH_OOI_CART: 'ARTSTORE_OOI_REFRESH_CART_ITEMS',
  SHOW_CART: 'ARTSTORE_OOI_SHOW_CART',
  OOI_CHECKOUT: 'ARTSTORE_OOI_CHECKOUT',
  ADD_TO_CART: 'ARTSTORE_OOI_ADD_TO_CART',
  UPDATE_CART_ITEM: 'ARTSTORE_OOI_UPDATE_CART_ITEM',
  OPEN_PROVIDER_MODAL: 'ARTSTORE_OOI_OPEN_PROVIDER_MODAL',
  CLEAR_CART: 'ARTSTORE_OOI_CLEAR_CART',
  REMOVE_FROM_CART: 'ARTSTORE_OOI_REMOVE_FROM_CART',
  REFRESH_BI_DATA: 'ARTSTORE_OOI_REFRESH_BI_DATA',
  BI_DATA_CHANGED: 'ARTSTORE_OOI_BI_DATA_CHANGED',
  REFRESH_CART: 'REFRESH_CART',
  CHECKOUT_STATE: 'CHECKOUT_STATE',
  CHECKOUT: 'STORE_CHECKOUT',
};
